export default __webpack_public_path__ + "static/media/eraser.6834b010.svg";